import React, { FC } from 'react';
import { connectStateResults, connectStats } from 'react-instantsearch-dom';

import { CustomStatsProps } from './models';

import './CustomStats.scss';

const Stats = ({ nbHits, followedText }) => (
  <p className="filters__stats">
    <span className="filters__stats--bold">{`${nbHits.toLocaleString()} `}</span>
    {followedText}
  </p>
);

const CustomStatsNumber = connectStats(Stats);

const StateResults = ({ searchState, followedText }) => (
  <>
    {!!searchState.query ||
    (!!searchState.refinementList && !!searchState.refinementList['articleTags.name']) ||
    (!!searchState.refinementList && !!searchState.refinementList.year) ||
    (!!searchState.refinementList && !!searchState.refinementList.documentType) ||
    (!!searchState.refinementList && !!searchState.refinementList['category.name']) ? (
      <CustomStatsNumber followedText={followedText} />
    ) : null}
  </>
);
const CustomStateResults = connectStateResults(StateResults);

const CustomStats: FC<CustomStatsProps> = ({ followedText }) => (
  <CustomStateResults followedText={followedText} />
);

export default CustomStats;
